import { ImportOutlined, InboxOutlined } from "@ant-design/icons";
import { Alert, Button, Form, Modal, Space, Upload } from "antd";
import { useForm } from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
import { publicApi } from "api/public.api";
import { useEffect, useState } from "react";
import { GuestType } from "types/guest";
import { formatExcelDate } from "utils/formatExcel";
// import { formatExcelDate } from "utils/formatExcelDate";
import * as XLSX from "xlsx";
const { Dragger } = Upload;

interface IShopData {
  name: string;
  phone: string;
  businessArea: string;
  companyName: string;
  ownerGender: string;
}

export const ImportRegisterModal = ({
  visible,
  onClose,
  onSubmitOk,
}: {
  visible: boolean;
  onClose: () => void;
  onSubmitOk: () => void;
}) => {
  const [loading, setLoading] = useState(false);
  const [excelData, setExcelData] = useState<any>();
  const [isDisabled, setisDisible] = useState(true);
  const [results, setResults] = useState<
    { status: string; message?: string }[]
  >([]);

  const [form] = useForm();

  useEffect(() => {
    if (visible) {
      form.resetFields();
      setResults([]);
    }
  }, [visible]);

  const generateGender = (value: string) => {
    if (!value) return "";
    switch (true) {
      case value.toLowerCase() == "ông":
        return "MALE";

      case value.toLowerCase() == "bà":
        return "FEMALE";

      default:
        return "";
    }
  };

  const readExcel = (file: any) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();

      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e) => {
        const bufferArray = e.target?.result;

        const wb = XLSX.read(bufferArray, { type: "buffer" });

        const wbname = wb.SheetNames[0];

        const ws = wb.Sheets[wbname];

        const data = XLSX.utils.sheet_to_json(ws, {
          range: 6,
        });

        resolve(data);
      };
    });

    promise.then((d) => {
      setisDisible(false);
      const data = Array(d);

      setExcelData(data[0]);
    });
  };

  const importData = () => {
    const dataPost = excelData.map((record: any) => {
      return {
        name: record["Họ và tên đệm"] + " " + record["Tên"],
        phone: record["Điện thoại"],
        businessArea: record["Chuyên ngành"],
        bookingDate: formatExcelDate(record["Ngày ghé thăm"]),
        shopName: record["Tên công ty"],
        gender: generateGender(record["Danh xưng"]),
        guestType:
          record["Loại khách mời"]?.toUpperCase() == "GUEST"
            ? GuestType.Guest
            : GuestType.Chapter,
      };
    });

    //post data
    dataPost.forEach((data: any, index: number) => {
      addCustomer(data, index);
    });

    onSubmitOk();
  };

  const addCustomer = async (data: IShopData, index: number) => {
    // debugger;
    setLoading(true);
    let message;
    let resultArr = results;

    //Check object not undefined

    try {
      const res = await publicApi.register({
        ...data,
      });
      if (res) {
        const status = "success";
        resultArr.push({ status, message });
        setResults([...resultArr]);
      }
    } catch (error: any) {
      const status = "error";
      message = `${error.response.data.message} (dòng ${index})`;
      resultArr.push({ status, message });
      setResults([...resultArr]);
    }

    setLoading(false);
  };

  return (
    (<Modal
      style={{ top: 50 }}
      onCancel={onClose}
      open={visible}
      title="Import Khách hàng"
      confirmLoading={loading}
      footer={[
        <Button
          type="primary"
          disabled={isDisabled}
          onClick={importData}
          icon={<ImportOutlined />}
          loading={loading}
        >
          Bắt đầu import
        </Button>,
        <Button onClick={onClose}>Đóng</Button>,
      ]}
    >
      {/* <Link to="/files/ImportMember.xlsx" target="_blank" download>
        <Space>
          <DownloadOutlined />
          Tải file excel mẫu
        </Space>
      </Link> */}
      <Form form={form}>
        <FormItem key="uploadField" name="uploadField">
          <Dragger
            style={{ marginTop: "0.5em" }}
            maxCount={1}
            multiple={false}
            beforeUpload={(file) => {
              //Check file type
              const isExcelFile =
                file.name.includes("xls") || file.name.includes("xlsx");
              if (!isExcelFile) {
                // message.error("Chỉ chấp nhận file XLSX/XLS!");
                // return Upload.LIST_IGNORE;
              }

              readExcel(file);
              return false;
            }}
            onChange={(info) => {
              //reset data
              setResults([]);
              if (info.fileList.length == 0) {
                setisDisible(true);
              }
            }}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Ấn vào đây hoặc kéo thả để tải file lên
            </p>
          </Dragger>
        </FormItem>
      </Form>
      {results.length > 0 && (
        <>
          <Alert
            style={{ marginTop: "1em", marginBottom: "1em" }}
            message={`${results.filter((r) => r.status == "success").length}
            khách hàng được thêm,
            ${results.filter((r) => r.status == "error").length} lỗi`}
            type="info"
            showIcon
          />
        </>
      )}
      {results.filter((r) => r.status == "error").length > 0 && (
        <>
          <b>Chi tiết lỗi:</b>
          <div className="error-container">
            {results
              .filter((r) => r.status == "error")
              .map((r, index) => (
                <>
                  <Alert
                    style={{ marginTop: "1em" }}
                    message={`${r.message}`}
                    type="error"
                    showIcon
                  />
                </>
              ))}
          </div>
        </>
      )}
      <Space
        style={{ width: "100%", justifyContent: "end", marginTop: "1em" }}
      ></Space>
    </Modal>)
  );
};
